const SEMANTIC_COLOR_VARS = {
	/** AUTO_GEN_FIGMA_SEMANTIC_COLOR_VARS_START */
	'text-default': '--color-text-default',
	'text-secondary': '--color-text-secondary',
	'text-tertiary': '--color-text-tertiary',
	'input-border': '--color-input-border',
	'tooltip-bg': '--color-tooltip-bg',
	'stroke-divider': '--color-stroke-divider',
	'button-secondary-bg': '--color-button-secondary-bg',
	'container-bg': '--color-container-bg',
	'main-bg': '--color-main-bg',
	black: '--color-black',
	white: '--color-white',
	'button-primary-bg': '--color-button-primary-bg',
	'purple-link': '--color-purple-link',
	'warn-orange': '--color-warn-orange',
	'negative-red': '--color-negative-red',
	'positive-green': '--color-positive-green',
	'input-bg': '--color-input-bg',
	'button-disabled': '--color-button-disabled',
	'text-disabled': '--color-text-disabled',
	'text-positive-green-button': '--color-text-positive-green-button',
	'text-negative-red-button': '--color-text-negative-red-button',
	overlay: '--color-overlay',
	'button-selector': '--color-button-selector',
	'negative-red-secondary-bg': '--color-negative-red-secondary-bg',
	'positive-green-secondary-bg': '--color-positive-green-secondary-bg',
	'warn-orange-secondary-bg': '--color-warn-orange-secondary-bg',
	'purple-bg': '--color-purple-bg',
	'button-primary-bg-hover': '--color-button-primary-bg-hover',
	'button-secondary-bg-hover': '--color-button-secondary-bg-hover',
	'star-yellow': '--color-star-yellow',
	'star-yellow-bg': '--color-star-yellow-bg',
	shadow: '--color-shadow',
	'purple-link-hover': '--color-purple-link-hover',
	'menu-bg': '--color-menu-bg',
	'selection-bg': '--color-selection-bg',
	/** AUTO_GEN_FIGMA_SEMANTIC_COLOR_VARS_END */
};

const BASE_COLOR_VARS = {
	/** AUTO_GEN_FIGMA_BASE_COLOR_VARS_START */
	'neutral-50': '--color-neutral-50',
	'neutral-100': '--color-neutral-100',
	'neutral-200': '--color-neutral-200',
	'neutral-300': '--color-neutral-300',
	'neutral-400': '--color-neutral-400',
	'neutral-500': '--color-neutral-500',
	'neutral-600': '--color-neutral-600',
	'neutral-700': '--color-neutral-700',
	'neutral-800': '--color-neutral-800',
	'neutral-900': '--color-neutral-900',
	'black-50': '--color-black-50',
	'black-100': '--color-black-100',
	'black-200': '--color-black-200',
	'black-300': '--color-black-300',
	'black-400': '--color-black-400',
	'black-500': '--color-black-500',
	'black-600': '--color-black-600',
	'black-700': '--color-black-700',
	'black-800': '--color-black-800',
	'black-900': '--color-black-900',
	'dark-blue-50': '--color-dark-blue-50',
	'dark-blue-100': '--color-dark-blue-100',
	'dark-blue-200': '--color-dark-blue-200',
	'dark-blue-300': '--color-dark-blue-300',
	'dark-blue-400': '--color-dark-blue-400',
	'dark-blue-500': '--color-dark-blue-500',
	'dark-blue-600': '--color-dark-blue-600',
	'dark-blue-700': '--color-dark-blue-700',
	'dark-blue-800': '--color-dark-blue-800',
	'dark-blue-900': '--color-dark-blue-900',
	'light-blue-50': '--color-light-blue-50',
	'royal-purple-50': '--color-royal-purple-50',
	'light-blue-100': '--color-light-blue-100',
	'light-blue-200': '--color-light-blue-200',
	'light-blue-300': '--color-light-blue-300',
	'light-blue-400': '--color-light-blue-400',
	'light-blue-500': '--color-light-blue-500',
	'light-blue-600': '--color-light-blue-600',
	'light-blue-700': '--color-light-blue-700',
	'light-blue-800': '--color-light-blue-800',
	'light-blue-900': '--color-light-blue-900',
	'green-50': '--color-green-50',
	'royal-purple-100': '--color-royal-purple-100',
	'royal-purple-200': '--color-royal-purple-200',
	'royal-purple-300': '--color-royal-purple-300',
	'royal-purple-400': '--color-royal-purple-400',
	'royal-purple-500': '--color-royal-purple-500',
	'royal-purple-600': '--color-royal-purple-600',
	'royal-purple-700': '--color-royal-purple-700',
	'royal-purple-800': '--color-royal-purple-800',
	'royal-purple-900': '--color-royal-purple-900',
	'red-50': '--color-red-50',
	'red-100': '--color-red-100',
	'red-200': '--color-red-200',
	'red-300': '--color-red-300',
	'red-400': '--color-red-400',
	'red-500': '--color-red-500',
	'red-600': '--color-red-600',
	'red-700': '--color-red-700',
	'red-800': '--color-red-800',
	'red-900': '--color-red-900',
	'green-100': '--color-green-100',
	'green-200': '--color-green-200',
	'green-300': '--color-green-300',
	'green-400': '--color-green-400',
	'green-500': '--color-green-500',
	'green-600': '--color-green-600',
	'green-700': '--color-green-700',
	'green-800': '--color-green-800',
	'green-900': '--color-green-900',
	'orange-50': '--color-orange-50',
	'orange-100': '--color-orange-100',
	'orange-200': '--color-orange-200',
	'orange-300': '--color-orange-300',
	'orange-400': '--color-orange-400',
	'orange-500': '--color-orange-500',
	'orange-600': '--color-orange-600',
	'orange-700': '--color-orange-700',
	'orange-800': '--color-orange-800',
	'orange-900': '--color-orange-900',
	'yellow-50': '--color-yellow-50',
	'yellow-100': '--color-yellow-100',
	'yellow-200': '--color-yellow-200',
	'yellow-300': '--color-yellow-300',
	'yellow-400': '--color-yellow-400',
	'yellow-500': '--color-yellow-500',
	'yellow-600': '--color-yellow-600',
	'yellow-700': '--color-yellow-700',
	'yellow-800': '--color-yellow-800',
	'yellow-900': '--color-yellow-900',
	/** AUTO_GEN_FIGMA_BASE_COLOR_VARS_END */
};

export const COLOR_VARS = {
	...SEMANTIC_COLOR_VARS,
	...BASE_COLOR_VARS,
} as const;
